<template>
    <el-pagination
        :current-page="pagination.current_page"
        :disabled="disabled"
        :page-size="pageSize"
        :total="pagination.total"
        @current-change="e => $emit('current-change', e)"
        @size-change="e => $emit('size-change', e)"
        background
        class="mt-3"
        v-if="pagination">
    </el-pagination>
</template>
<script>
    export default {
        props: {
            pagination: {
                type: Object,
            },
            disabled: {
                default: false,
            }
        },
        computed: {
            pageSize() {
                if (!this.pagination) {
                    return null
                }
                return parseInt(this.pagination.per_page)
            }
        },
    }
</script>

<style scoped>

</style>
